import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, Star, Users, Rocket } from "lucide-react";

interface ChoosePathModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ChoosePathModal = ({ open, onOpenChange }: ChoosePathModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto p-8">
        <DialogHeader className="mb-6">
          <DialogTitle className="text-3xl md:text-4xl font-bold text-center text-[#2e4053]">
            Choose Your Path
          </DialogTitle>
          <p className="text-center text-[#2e4053]/70 text-lg mt-2">
            Select the experience that fits your journey.
          </p>
        </DialogHeader>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Community Pass */}
          <div className="p-8 bg-white rounded-2xl border-2 border-[#d8239b]/30 text-center shadow-lg hover:shadow-xl transition-shadow">
            {/* Icon */}
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#d8239b]/20 to-[#ff69b4]/20 flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-[#d8239b]" />
            </div>
            
            <h3 className="font-bold text-2xl text-[#2e4053] mb-2">Community Pass</h3>
            <p className="text-[#d8239b] font-bold text-xl mb-2">Pay What You Can</p>
            <p className="text-[#2e4053]/60 text-sm mb-6">Great for agents getting started.</p>
            
            <ul className="text-left space-y-3 mb-8">
              <li className="flex items-center gap-3 text-[#2e4053]/80">
                <CheckCircle className="w-5 h-5 text-[#d8239b] flex-shrink-0" />
                <span>Days 1-3 Live Sessions</span>
              </li>
              <li className="flex items-center gap-3 text-[#2e4053]/80">
                <CheckCircle className="w-5 h-5 text-[#d8239b] flex-shrink-0" />
                <span>Live Q&A</span>
              </li>
              <li className="flex items-center gap-3 text-[#2e4053]/80">
                <CheckCircle className="w-5 h-5 text-[#d8239b] flex-shrink-0" />
                <span>Community Access</span>
              </li>
            </ul>
            
            <Button 
              size="lg" 
              variant="outline"
              className="w-full border-2 border-[#d8239b] text-[#d8239b] hover:bg-[#d8239b]/10 font-bold py-6 text-lg"
              onClick={() => window.open('https://donate.stripe.com/14A28q1Fjaa44G73ek8k800', '_blank')}
            >
              Choose Your Price
            </Button>
          </div>

          {/* VIP Builder Pass */}
          <div className="relative p-8 bg-gradient-to-br from-[#1a1a2e] to-[#2e4053] rounded-2xl border-2 border-[#d8239b] text-center shadow-xl">
            {/* Most Popular Badge */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1.5 bg-gradient-to-r from-[#d8239b] to-[#ff69b4] text-white font-bold text-xs rounded-full flex items-center gap-1.5 shadow-lg">
              <Star className="w-3.5 h-3.5" />
              MOST POPULAR
            </div>
            
            {/* Icon */}
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#d8239b] to-[#ff69b4] flex items-center justify-center mx-auto mb-4 mt-2">
              <Rocket className="w-8 h-8 text-white" />
            </div>
            
            {/* Scarcity Badge */}
            <div className="text-[#ff4444] font-bold text-sm mb-2">
              ⚠️ Only 25 seats available
            </div>
            
            <h3 className="font-bold text-2xl text-white mb-2">VIP Builder Pass</h3>
            <p className="text-[#ff69b4] font-bold text-xl mb-1">$97 <span className="text-base font-normal text-white/60">One-Time</span></p>
            <p className="text-white/60 text-sm mb-6">Everything in Community Pass, plus:</p>
            
            <ul className="text-left space-y-3 mb-8">
              <li className="flex items-center gap-3 text-white/90">
                <CheckCircle className="w-5 h-5 text-[#ff69b4] flex-shrink-0" />
                <span>VIP Day 4 Included</span>
              </li>
              <li className="flex items-center gap-3 text-white/90">
                <CheckCircle className="w-5 h-5 text-[#ff69b4] flex-shrink-0" />
                <span>Lifetime Recordings</span>
              </li>
              <li className="flex items-center gap-3 text-white/90">
                <CheckCircle className="w-5 h-5 text-[#ff69b4] flex-shrink-0" />
                <span>Build Your Digital Product</span>
              </li>
            </ul>
            
            <Button 
              size="lg" 
              className="w-full bg-gradient-to-r from-[#d8239b] to-[#ff69b4] hover:from-[#d8239b]/90 hover:to-[#ff69b4]/90 text-white font-bold py-6 text-lg shadow-lg"
              onClick={() => window.open('https://buy.stripe.com/dRm9ATdsrbWMd6jev45c400', '_blank')}
            >
              Upgrade to VIP
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ChoosePathModal;
